// export const apiurl = "https://api-xpresschat.fixall.ai";
// export const apiurl = "https://6c5f-103-206-131-194.ngrok-free.app";
// export const apiurl = "https://victor.fixall.ai";
export const apiurl = "https://vibe.fixall.ai/backend";


export const accessKeyId = process.env.REACT_APP_ACCESS_KEY_ID;
export const secretAccessKey = process.env.REACT_APP_SECRET_ACCESS_KEY;
export const region = process.env.REACT_APP_AWS_REGION;
export const bucket = process.env.REACT_APP_AWS_BUCKET;